var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Box, Icon } from '@noom/wax-component-library';
import SideMenuActionItem from '../../../core/components/SideMenuActionItem';
import { ListHeading } from '../../../core/components/SideMenuSection';
import { Plus, CommunityNoom } from '../../../icons';
import CommunitiesList from '../../../social/components/CommunitiesList';
import CommunityCreationModal from '../../../social/components/CommunityCreationModal';
import { useConfig } from '../../../social/providers/ConfigProvider';
import { useNavigation } from '../../../social/providers/NavigationProvider';
import { useSDK } from '../../../core/hooks/useSDK';
import withSDK from '../../../core/hocs/withSDK';
import useUser from '../../../core/hooks/useUser';
import { getUserType } from '../../../helpers/userTypes';
import { BUSINESS_TYPE_METADATA } from '../../../social/constants';
const CommunityCount = (_a) => {
    var { count = 0 } = _a, styles = __rest(_a, ["count"]);
    return React.createElement(Box, Object.assign({}, styles), count);
};
const SideSectionMyCommunity = ({ className, activeCommunity, communityListProps, canCreatePublicCommunity, currentUserId, }) => {
    var _a;
    const { connected } = useSDK();
    const { socialCommunityCreationButtonVisible, showCreateCommunity } = useConfig();
    const { onCommunityCreated } = useNavigation();
    const [isOpen, setIsOpen] = useState(false);
    const { user } = useUser(currentUserId, [currentUserId]);
    const userType = getUserType(user);
    const open = () => setIsOpen(true);
    const close = (communityId) => {
        setIsOpen(false);
        communityId && onCommunityCreated(communityId);
    };
    return (React.createElement(Box, { bg: "white", h: "100%", pb: 2, pt: 1 },
        React.createElement(ListHeading, null,
            React.createElement(Icon, { h: 8, w: 8, ml: 0 },
                React.createElement(CommunityNoom, null)),
            React.createElement(FormattedMessage, { id: "SideSectionMyCommunity.myCommunity" }),
            React.createElement(CommunityCount, { ml: "auto", count: (_a = communityListProps === null || communityListProps === void 0 ? void 0 : communityListProps.communities) === null || _a === void 0 ? void 0 : _a.length })),
        React.createElement(Box, { h: "calc(100% - 50px)", minH: 0, overflow: "auto" },
            showCreateCommunity && (React.createElement(SideMenuActionItem, { icon: React.createElement(Plus, { height: 20 }), element: "button", disabled: !connected, onClick: open, "data-qa-anchor": "side-section-my-community-create-community-button" },
                React.createElement(FormattedMessage, { id: "createCommunity" }))),
            React.createElement(CommunitiesList, Object.assign({ className: className, activeCommunity: activeCommunity }, communityListProps))),
        React.createElement(CommunityCreationModal, { isOpen: isOpen, onClose: close, canCreatePublic: canCreatePublicCommunity })));
};
SideSectionMyCommunity.propTypes = {
    className: PropTypes.string,
    activeCommunity: PropTypes.string,
    canCreatePublicCommunity: PropTypes.bool,
    currentUserId: PropTypes.string.isRequired,
};
export default memo(withSDK(SideSectionMyCommunity));
//# sourceMappingURL=index.js.map